import React from 'react';
import PropTypes from 'prop-types';

/**
 * A sliding scale input which matches the API of the react-native analog.
 */
export default function Slider({
  onValueChange,
  className,
  minimumValue,
  maximumValue,
  value,
  step,
  ...restProps
}) {
  const handleChange = evt => {
    if (typeof onValueChange === 'function') {
      onValueChange(evt.target.value);
    }
  };

  return (
    <input
      {...restProps}
      type="range"
      className={className}
      value={value}
      min={minimumValue}
      max={maximumValue}
      step={step}
      onChange={handleChange}
    />
  );
}

Slider.propTypes = {
  /** Called when the value changes, given the current numerical value */
  onValueChange: PropTypes.func,
  /** Styles to apply to the slider */
  className: PropTypes.string,
  /** The minimum value for the slider */
  minimumValue: PropTypes.number,
  /** The maximum value for the slider */
  maximumValue: PropTypes.number,
  /** The current value of the slider */
  value: PropTypes.number.isRequired,
  /** The delta between distinct values */
  step: PropTypes.number,
};

Slider.defaultProps = {
  onValueChange: null,
  className: '',
  minimumValue: 0,
  maximumValue: 1,
  step: 0,
};
